import { render, staticRenderFns } from "./CVTypeSchool.vue?vue&type=template&id=6f330b19"
import script from "./CVTypeSchool.vue?vue&type=script&lang=js"
export * from "./CVTypeSchool.vue?vue&type=script&lang=js"
import style0 from "./CVTypeSchool.vue?vue&type=style&index=0&id=6f330b19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports